export default __webpack_public_path__ + "static/kb_1_2-e5833b51ffe4f635858a79e577d0df29.jpeg";